export const valueToPercent = (value: any) => (value ? value / 100 : value);
